<div class="content-wrapper">
    <div class="content-body">
        <section id="package">
            <ng-template #content>
                <div id="modal">
                    <div class="modal-header font-weight-bold">
                        <h4 class="modal-title font-weight-bold">Update Status</h4>
                        <button
                                type="button"
                                class="close"
                                data-dismiss="modal"
                                aria-label="Close"
                                (click)="modalService.dismissAll('')"
                        >
                            ×
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                <form class="form" novalidate [formGroup]="updateStatusForm">
                                    <div class="px-3 container">
                                        <div class="row">
                                            <div class="col-12">
                                                <div class="form-group">
                                                    <label for="status" class="d-flex">
                                                        Status
                                                    </label>
                                                    <select class="form-control" id="status"
                                                            formControlName="status">
                                                        <option value="">Select status</option>
                                                        <option>IN PROGRESS</option>
                                                        <option>COMPLETED</option>
                                                    </select>
                                                    <!--<small *ngIf="submitted && updatePasswordForm.get('password').hasError('required')"
                                                           class="text-danger">
                                                        Field is required.
                                                    </small>-->
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button class="btn btn-success color-white pull-right" [disabled]="submitting"
                        >
                            <i class="fas fa-pen-square mr-1" *ngIf="!submitting"></i>
                            <i class="fas fa-spinner fa-pulse mr-1" *ngIf="submitting"></i>Update
                        </button>
                    </div>
                </div>
            </ng-template>
            <div class="row">
                <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-12">
                    <h2 class="mt-5px">Address</h2>
                </div>
                <div class="col-xl-9 col-lg-9 col-md-9 col-sm-9 col-xs-12">
                    <button class="btn btn-primary pull-right color-white color-white users-btn mr-2"
                            (click)="showSearch = !showSearch">
                        <i aria-hidden="true" class="fa fa-search mr-8px"></i>&nbsp;Search
                    </button>
                    <button class="btn btn-primary pull-right color-white color-white users-btn mr-2"
                            (click)="add()">
                        <i aria-hidden="true" class="fa fa-home mr-8px"></i>&nbsp;Add Address
                    </button>
                </div>
            </div>
            <div class="row search-card mt-3" *ngIf="showSearch">
                <div class="col-12">
                    <form class="form mt-2 mb--8px" novalidate [formGroup]="searchForm">
                        <div class="row">
                            <div class="col-md-3 col-lg-3 col-sm-3 col-xs-12">
                                <fieldset class="form-group">
                                    <input class="form-control" type="text" formControlName="name"
                                           placeholder="Name.">
                                </fieldset>
                            </div>
                            <div class="col-md-3 col-lg-3 col-sm-3 col-xs-12">
                                <fieldset class="form-group">
                                    <input class="form-control" type="number" formControlName="pin_code"
                                           placeholder="Pin Code">
                                </fieldset>
                            </div>
                            <div class="col-md-3 col-lg-3 col-sm-3 col-xs-12">
                                <fieldset class="form-group">
                                    <select class="form-control" formControlName="state_id">
                                        <option value="">Select State</option>
                                        <option [value]="state?.id" *ngFor="let state of states">{{state?.name}}</option>
                                    </select>
                                </fieldset>
                            </div>
                            <div class="col-md-3 col-lg-3 col-sm-3 col-xs-12 text-center">
                                <button class="btn btn-primary btn-block btn-raised color-white mr-2 users-btn"
                                        (click)="search()"
                                        [disabled]="submitting">
                                    <i class="fas fa-spinner fa-pulse mr-1" *ngIf="submitting"></i>Search
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <div class="row mt-3">
                <div class="col-12">
                    <div class="card" *ngFor="let address of addresses; let i = index">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-12 text-center mt-auto mb-auto">
                                    <span class="f_20 font-weight-bold">{{(pagination.page - 1) * (pagination.perpage ? pagination.perpage : 0) + i + 1}}.</span>
                                </div>
                                <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-12 text-center mt-auto mb-auto">
                                    <span class="font-weight-bold text-italic f_15">{{address?.name}}</span>
                                    <br>
                                    <small class="text-italic">Contact Person Name</small>
                                </div>
                                <div class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-12 text-center mt-auto mb-auto">
                                    <span class="font-weight-bold text-italic f_15">{{address?.contact}}</span>
                                    <br>
                                    <small class="text-italic">Contact No.</small>
                                </div>
                                <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-12 text-center mt-auto mb-auto">
                                    <span class="font-weight-bold text-italic f_15 cursor-pointer">{{address?.address}}</span>
                                    <br>
                                    <small class="text-italic">Address</small>
                                </div>
                                <div class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-12 text-center mt-auto mb-auto">

                                    <span class="font-weight-bold text-italic f_15 ">{{address?.city}}</span>
                                    <br>
                                    <small class="text-italic">City/Town</small>
                                </div>
                                <div class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-12 text-center mt-auto mb-auto">
                                    <div>
                                        <span class="font-weight-bold text-italic f_15"
                                        >{{address['state']?.name}}</span>
                                        <br>
                                        <small class="text-italic">State</small>
                                    </div>
                                </div>
                                <div class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-12 text-center mt-auto mb-auto">
                                    <span class="font-weight-bold text-italic f_15 cursor-pointer"> {{address?.pin_code}}
                                    </span>
                                    <br>
                                    <small class="text-italic">Pin code</small>
                                </div>
                                <div class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-12 text-center mt-auto mb-auto">
                                    <div>
                                        <span class="font-weight-bold text-italic f_15" *ngIf="address?.gst_no"
                                        >{{address?.gst_no}}</span>
                                        <span class="font-weight-bold text-italic f_15" *ngIf="!address?.gst_no"
                                        >-</span>
                                        <br>
                                        <small class="text-italic">GSTIN</small>
                                    </div>
                                </div>
                                <div class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-12 text-center  mt-auto mb-auto">
                                    <span class="font-weight-bold text-italic f_15 cursor-pointer text-success" title="Edit Address" (click)="edit(address)">
                                        <i class="fa fa-edit f_20"></i>
                                    </span>
                                    <br>
                                    <small class="text-italic">Action</small>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ng-template #noDataToShow>
                <div class="row mt-3">
                    <div class="col-12">
                        <div class="card p-50px">
                            <div class="card-body text-center">
                                <div class="row">
                                    <div class="col-12">
                                        <i class="fa fa-list-alt fa-3x" aria-hidden="true"></i>
                                    </div>
                                    <div class="col-12 text-center">
                                        No Address to show
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>
            <div class="row pagination-table">
            </div>
        </section>
        <core-sidebar
                class="modal modal-slide-in sidebar-todo-modal fade"
                name="add-address"
                overlayClass="modal-backdrop">
            <app-add-address [data]="data" (valueSubmitted)="getData($event)"></app-add-address>
        </core-sidebar>
    </div>
</div>
